import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionPatient } from "../../../redux/actions";
import { Inputs } from "../../../components";
import { useTranslation } from "react-i18next";

const HearingAndSeeing = ({ loginData, activeTab, tabId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const getQuestionData2 = useSelector(
        (state) => state.patient.getQuestionData2?.data?.result || []
    );
    const getAnswersData2 = useSelector(
        (state) => state.patient.getAnswersData2?.data?.result || []
    );
    const [answersData, setAnswersData] = useState([]);

    useEffect(() => {
        if (JSON.stringify(answersData) !== JSON.stringify(getAnswersData2)) {
            setAnswersData(getAnswersData2);
        }
    }, [answersData, getAnswersData2]);

    function handleAnswerChange(questionGuid, ans) {
        setAnswersData((prevAnswers) => prevAnswers.map((item) => item.questionGuid === questionGuid
            ? {
                ...item,
                answer1: ans,
                answer2: ans === "NA" ? null : ans === "No" ? "" : item.answer2,
            }
            : item
        )
        );
    }

    useEffect(() => {
        if (
            activeTab === tabId &&
            loginData?.userGuid &&
            loginData?.languageAbb
        ) {
            dispatch(actionPatient.getQuestion2(loginData.languageAbb));
            dispatch(actionPatient.getAnswers2(loginData.userGuid));
        }
    }, [activeTab, tabId, loginData?.languageAbb, loginData?.userGuid, dispatch]);

    return (
        <div>
            {getQuestionData2.map((que, index) => {
                const matchedAnswer = answersData.find(
                    (ans) => ans.questionGuid === que.questionGuid
                );
                const selectedValue = matchedAnswer?.answer1;

                return (
                    <div key={index} className="health-info-que-ans-tab-blk">
                        <p className="exado-title-seven health-info-que">{que.question}</p>

                        {que.questionType === 1 && (
                            <div className="health-info-ans-radio-blk">
                                <Inputs.CheckRadioInput
                                    type="radio"
                                    label={t("yes")}
                                    name={`answer-${que.questionGuid}`}
                                    className="form-grp-radio"
                                    checked={selectedValue === "Yes"}
                                    onChange={() => handleAnswerChange(que.questionGuid, "Yes")}
                                />
                                <Inputs.CheckRadioInput
                                    type="radio"
                                    label={t("no")}
                                    name={`answer-${que.questionGuid}`}
                                    className="form-grp-radio"
                                    checked={selectedValue === "No"}
                                    onChange={() => handleAnswerChange(que.questionGuid, "No")}
                                />
                                <Inputs.CheckRadioInput
                                    type="radio"
                                    label={t("dont_know")}
                                    name={`answer-${que.questionGuid}`}
                                    className="form-grp-radio"
                                    checked={selectedValue === "NA"}
                                    onChange={() => handleAnswerChange(que.questionGuid, "NA")}
                                />
                            </div>
                        )}

                        {selectedValue === "Yes" && (
                            <Inputs.FormInputs
                                type="textarea"
                                label={t("patient_Details.health_information.additional_info")}
                                value={matchedAnswer?.answer2 || ""}
                                readOnly={true}
                                grpClassname="form-group"
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default HearingAndSeeing;
